class RiskLevelervice {
    get_risk_level(page, data) {
        return axios.get('general/risk_levels?page=' + page)
    }
    get_risk_levels(id) {
        return axios.get('general/risk_levels/edit/' + id)
    }
    add_risk_levels(data) {
        return axios.post('general/risk_levels/store', data)
    }
    edit_risk_levels(id, data) {
        return axios.post('general/risk_levels/update/' + id, data)
    }
    delete_risk_levels(id) {
        return axios.delete('general/risk_levels/delete/' + id)
    }

}
export default new RiskLevelervice();